import * as React from "react";
import { Link, Theme, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import { tutorialLinks } from "./tutorialLinks";
import { KeyValue } from "../../../interfaces";
const useStyles = makeStyles((theme: Theme) => ({
  ul: { marginTop: 0 },
  list: {
    "color": theme.palette.primary.main,
    "lineHeight": "1.5rem",
    "& .MuiTypography-body2": {
      paddingBottom: 4,
    },
  },
}));

export default function Tutorials() {
  const classes = useStyles();
  const baseDownloadUrl =
    "https://s3-us-gov-west-1.amazonaws.com/cg-2e5c99a6-e282-42bf-9844-35f5430338a5/downloads/";
  return (
    <>
      <Typography variant="body2" color="primary">
        Tutorial topics have been organized by their BankFind Suite usage to
        aide in locating relevant content.
      </Typography>
      {tutorialLinks.map((topic: KeyValue) => {
        return (
          <React.Fragment key={topic.header}>
            <Typography variant="h3" style={{ paddingBottom: 0 }}>
              {topic.header}
            </Typography>
            <ul className={classes.ul}>
              {topic.links.map((link: KeyValue) => {
                return (
                  <li className={classes.list} key={link.title}>
                    <Typography variant="body2">
                      <Link
                        href={
                          link.directLink
                            ? link.fileName
                            : `${baseDownloadUrl}${link.fileName}`
                        }
                        target={link.download ? "" : "_blank"}
                      >
                        {link.title}
                      </Link>
                    </Typography>
                  </li>
                );
              })}
            </ul>
          </React.Fragment>
        );
      })}
    </>
  );
}
